import React, { Component } from 'react';
import { Col, Row } from 'react-grid-system';

import classNames from 'classnames';
import { I18n } from 'components/translate';
import PropTypes from 'prop-types';

import './DeepSearchRow.scss';

export default class DeepSearchRow extends Component {
  static propTypes = {
    children: PropTypes.node,
    label: PropTypes.string,
    noMargin: PropTypes.bool,
    additionalInfo: PropTypes.string
  };

  render() {
    const { children, label, noMargin, additionalInfo } = this.props;
    const rowClasses = classNames('deep__search__row', {
      'deep__search__row--margin': !noMargin
    });

    return (
      <Row nogutter className={rowClasses} align="center">
        <Col sm={3} xs={12} className="deep__search__label__text">
          {label && <I18n label={label} />} {additionalInfo}
        </Col>
        <Col sm={9} xs={12} className="deep__search__field">
          {children}
        </Col>
      </Row>
    );
  }
}
